// extracted by mini-css-extract-plugin
export default {"sticky-bottom":"AmctLxFHZqbAHU5BgDUw","notice":"aQfnhrZifLCfhfUx6zzk","notice-content":"rltS0HWgcX3PkmLxj68v","close-notice":"nLZizncvv2TKaW8k8hHp"};